import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * The skip-ahead chevron that floats on the right edge of a practice card.
 * Fixed to the viewport so it stays centred vertically regardless of card
 * length or scroll position, and sits deliberately on the card's right edge
 * so it reads as an obvious "next" affordance.
 *
 * Shared by Manual and Automatic so the two modes cannot drift apart. `label`
 * describes what the tap actually does at that point in the flow — Automatic
 * uses it mid-playback, where the arrow moves on to the feedback rather than
 * to the next phrase.
 *
 * `back` mirrors it onto the left edge to go back a phrase (Leanne, 4 Nov 2026).
 * `inline` drops the fixed edge position so the arrow sits in a row of
 * controls: Automatic puts both arrows either side of Pause/Resume.
 */
// right-0, not right-2: on a phone the chevron sat over the card's content;
// hard against the screen edge it sits on the card border (Leanne, 27 Oct 2026).
export default function NextPhraseButton({ onClick, testId, back = false, inline = false, label = back ? 'Previous phrase' : 'Next phrase' }) {
    const Chevron = back ? ChevronLeft : ChevronRight;
    return (
        <button
            type="button"
            data-testid={testId}
            onClick={onClick}
            aria-label={label}
            title={label}
            className={`${inline ? '' : `fixed top-1/2 ${back ? 'left-0' : 'right-0'} -translate-y-1/2 z-50 `}inline-flex items-center justify-center text-primary hover:text-primary/80`}
        >
            <Chevron className="h-10 w-10" strokeWidth={2.75} />
        </button>
    );
}
